import React, { useState, useEffect } from 'react';
import { Spin, Empty } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import DocsList from './DocsList';
import useCardPagination from '../../../../../hooks/useCardPagination';
import { ReactComponent as AddFileIcon } from '../../../../../resource/AddFileIcon.svg';
import { CardButton } from '../../../../../components/Card';
import { getReplacedString } from '../../../../../helpers/getReplacedString';
import SearchField from '../../../../../components/SearchField/SearchField';
import styles from './Documents.module.scss';

const pageSize = 5;

const filterDocs = ({ docs, search }) =>
  docs.filter((item) => {
    const value = getReplacedString(search);
    const name = getReplacedString(item.name);

    return name.includes(value);
  });

const Documents = ({
  className,
  docs = [],
  title,
  loading = false,
  getAttachmentUrl,
  onDeleteDocument,
  onAddBtnClick,
  onEditClick,
  darkTheme = true,
  titleClassName,
  showAdditionalContent,
  showActions,
  renderAddBtn,
  attachmentClassName,
  headerClassName,
  columnAmount,
  showPaginationOnBottom = false,
}) => {
  const [search, setSearch] = useState('');
  const [filteredDocs, setFilteredDocs] = useState(docs);

  const { shownItems, pagination } = useCardPagination(filteredDocs, pageSize);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    let newDocs = [];

    if (docs.length) {
      newDocs = search.trim()
        ? filterDocs({ docs, search: search.trim() })
        : docs;
    }

    setFilteredDocs(newDocs);
  }, [JSON.stringify(docs), search]);

  return (
    <InfoCard
      title={title}
      action={docs.length > pageSize ? pagination : null}
      className={className}
      dark={darkTheme}
      titleClassName={titleClassName}
      headerClassName={headerClassName}
    >
      <Spin spinning={loading}>
        {!docs.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            {docs.length > pageSize && (
              <SearchField
                placeholder="Поиск по названию документа"
                value={search}
                onChange={handleSearchChange}
              />
            )}
            <DocsList
              items={shownItems}
              allDocs={docs}
              getAttachmentUrl={getAttachmentUrl}
              onDeleteDocument={onDeleteDocument}
              onEditClick={onEditClick}
              showAdditionalContent={showAdditionalContent}
              showActions={showActions}
              attachmentClassName={attachmentClassName}
              columnAmount={columnAmount}
            />
          </>
        )}
        {typeof onAddBtnClick === 'function' &&
          typeof renderAddBtn !== 'function' && (
            <CardButton
              className={styles.uploadButton}
              block
              text="Добавить документ(ы)"
              icon={<AddFileIcon />}
              onClick={onAddBtnClick}
            />
          )}
        {typeof renderAddBtn === 'function' && renderAddBtn()}
        {showPaginationOnBottom && docs.length > pageSize ? pagination : null}
      </Spin>
    </InfoCard>
  );
};

export default Documents;
